import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'
import { brandConfig } from '../../../config/brandConfig'

export const StyledWrapper = styled.div`
  width: 240px;
  min-height: 150px;
  right: 45px;
  top: 55px;
  border-radius: 5px;
  box-shadow: 0 3px 4px 0 rgb(0 0 0 / 20%);
  position: absolute;
  background-color: ${themeStyles.colors.white.main};
  color: ${themeStyles.colors.darkGreys[5].main};
  z-index: 99999;

  &:before {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-bottom-color: ${themeStyles.colors.white.main};
    border-width: 8px;
    margin-left: -8px;
  }
  #dropdown-menu-deposit,
  #dropdown-menu-withdraw {
    > div {
      margin-left: 4px;
    }
  }
`

export const StyledRow = styled.div`
  display: flex;
  border-top: 1px solid ${themeStyles.colors.lightGreys[2].main};
  padding: 0.25rem 0.7rem;
  cursor: pointer;

  &:hover {
    background-color: ${themeStyles.colors.white.main};
  }

  > span {
    width: 80%;
    flex: 1 0 80%;
  }
`

export const StyledIcon = styled.div.attrs((props) => ({
  icon: props.icon || '',
}))`
  width: 20%;
  flex: 1 0 20%;
  background: url(${(props) => props.icon}) left center no-repeat;
  background-size: 30px;
`

export const StyledCashbackAmount = styled.div`
  padding: 1rem 0.7rem;
  font-size: ${brandConfig.fonts.text.small.size.mobile};
  line-height: ${brandConfig.fonts.text.small.size.mobile};
  font-weight: 700;

  .amount {
    font-weight: 400;
  }
`

export const TagWrapper = styled.div`
  float: right;
  transform: translateX(-100%);
`
